import { render, staticRenderFns } from "./CreateNormativeBase.vue?vue&type=template&id=292eaf10&"
import script from "./CreateNormativeBase.vue?vue&type=script&lang=js&"
export * from "./CreateNormativeBase.vue?vue&type=script&lang=js&"
import style0 from "./CreateNormativeBase.vue?vue&type=style&index=0&id=292eaf10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports